import { CircularProgress, Grid, MenuItem } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ReactSVG } from "react-svg";
import api from "../../../../../../api/api";
import imgs from "../../../../../../assets/images/imgs";
import StudentTeacherprofileChatbot from "../../../../../../components/StudentTeacherprofileChatbot";
import { useAuth } from "../../../../../../features/auth/AuthContext";
import StudentDashboardChatbot from "../chatbot/StudentChatbot";
import StudentSuggesionCourseData from "../course/StudentSuggesionCourseData";
import StudentSuggesionTeacherCard from "../course/StudentSuggesionTeacherCard";
import { useNavigate } from "react-router";
import FilteredInput from "../../../../../../components/FilteredInput/FilteredInput";
import { updateGlobalState } from "../../../../../../state/global/slice";
import OverallPerformanceDashboard from "../../../../../../components/OverallPerformanceDashboard/OverallPerformanceDashboard";
import "./MarketPlace.css";
//  import "./../../../dashboard/Filter.css";
import Filter from "../../Filter";
import { arrow_outward, down_arrow, FilterSVG, sort } from "../../../../../../assets/images/images";
import StyledMenu from "../../../../../../components/StyleMenu";
import FloatingAIButton from "../../../../../../components/FloatingAIButton/FloatingAIButton";
import { setDrawerState, setIsWebAllowed, setQueryMetaData } from "../../../../../../state/reducers/chatDrawerReducers";
import { resetAddToCart } from "../../../../../../state/reducers/addToCartReducer";
import { toast } from "react-toastify";





const MarketPlace = () => {
  const navigate = useNavigate();
  const globalState = useSelector((state) => state.globalState);
  const chatDrawerState = useSelector((state) => state?.ChatDrawerState);

  const dispatch = useDispatch();
  const [TempglobalState, setTempglobalState] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [filter, setFilter] = useState("");//filter state to send in api
  const addToCartData = useSelector((state) => state.addToCart);
  const removeCart = useSelector((state) => state.removeCartData);






  const get_teacher_list = globalState?.get_teacher_list?.data ?? [];
  const [showteacherProfile, setShowteacherProfile] = useState(false); // State to control visibility

  const modalRef = useRef();
  const modalContentRef = useRef(); // Reference to the modal content

  // Function to open the modal
  const openModal = () => {
    setShowteacherProfile(true);
  };


  const toggleteacherProfile = () => {
    setShowteacherProfile(false); // Toggle the visibility state
  };

  const updateState = (key, value) => {
    dispatch(updateGlobalState({ key: key, value: value }));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalContentRef.current && !modalContentRef.current.contains(event.target)) {
        toggleteacherProfile();
      }
    };

    // Attach the event listener
    if (showteacherProfile) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    // Cleanup the event listener
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showteacherProfile]);


  const [search, setSearch] = useState("");
  const serachhandleInputChange = (event) => {
    const { value } = event.target;
    setSearch(value);
    setCurrentPage(1); // Reset to page 1 when search changes
  };
  const changeSubjectFillter = (value) => {
    setSelectedSubject(value);
    const selectedSubject = value;
    // console.warn("selected syvhect", selectedSubject);
    setTempglobalState(selectedSubject);
    setCurrentPage(1); // Reset to page 1 when filter changes
  };
  const statusPriority = (status) => {
    switch (status) {
      case "Pending":
        return 1;
      case "Active":
        return 2;
      default:
        return 3;
    }
  };

  const { token } = useAuth();
  const [courses, setCourses] = useState(globalState?.student_courses);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [nextUrl, setNextUrl] = useState(null);
  const [prevUrl, setPrevUrl] = useState(null);
  const itemsPerPage = 12; // Define number of items per page
    const [result , setresult] = useState(0);

  // Function to fetch courses using Axios
  const [loading, setLoading] = useState(false); // Add this state to your component

  const [debouncedSearch, setDebouncedSearch] = useState(search);
  const [open, setOpen] = useState(false);//filter button drawer state


  useEffect(() => {
    setCurrentPage(1);
  }, [filter]);

  const fetchCourses = async (page) => {
    try {
      setLoading(true); // Set loading to true before the request
      const response = await api.post(`courses/student/my-courses-dashboard/v2/`, {
        page: page,
        search: search,
        sort: TempglobalState,
        subject: filter.subjects,
        courses: filter.courses,
        pricing: filter.pricing,
        course_status: filter.course_status,
        ratings: filter.ratings,
        view_all: "all",
        browse_by: filter.browse_by,
      },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        });

      const data = response.data;

      setCourses(data.data);
      setLoading(false);
      setTotalPages(
        data.result_count >= 5
          ? Math.ceil(data.result_count / itemsPerPage)
          : Math.floor(data.result_count / itemsPerPage)
      ); // Calculate total pages
      setNextUrl(data.next); // Update next URL
      setPrevUrl(data.previous); // Update previous URL
    } catch (error) {
      console.error("Fetching error:", error);
    } finally {
      setLoading(false); // Set loading to false after the request is completed or if an error occurs
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [search]);


  // Effect to fetch data when currentPage changes
  useEffect(() => {
    fetchCourses(currentPage);
    // }, [currentPage, TempglobalState, search, globalState.student_details]);
  }, [currentPage, debouncedSearch, TempglobalState, filter]);



  // Function to handle page change
  const handlePageChange = (event, value) => {
    window.scrollTo(0, 0);
    setCurrentPage(value);
  };

  const handleNavigateAway = () => {
    localStorage.setItem("studentHomeScrollPosition", window.pageYOffset);
  };



  const activeCourses =
    globalState?.student_details?.data?.my_courses?.active_courses;

  const assignmentsCount =
    globalState?.student_details?.data?.my_courses?.pending_assignments;
  // Correct: Creating a copy of the array and then sorting
  let coursesSortedArray = [];

  if (
    Array.isArray(courses) &&
    courses.length
  ) {
    coursesSortedArray = [...courses].sort((a, b) => {
      return statusPriority(a.status) - statusPriority(b.status);
    });
  }

  // // === New: Sequential display logic for courseType === 2 ===
  // const serialOrder = ["1", "2", "3", "4", "5"];

  // function getCourseToShowSequentially(allCourses) {
  //   if (!Array.isArray(allCourses)) return null;

  //   // Filter courses where courseType == 2
  //   const filtered = allCourses.filter(c => c.type === 2);

  //   // Sort by serialNumber order
  //   filtered.sort(
  //     (a, b) => serialOrder.indexOf(a.comp_course_serial_no) - serialOrder.indexOf(b.comp_course_serial_no)
  //   );

  //   // Return first course which is not completed
  //   for (const course of filtered) {
  //     if ((course.status ?? "").toLowerCase() !== "completed") {
  //       return course;
  //     }
  //   }

  //   // All completed? Return null (nothing to show)
  //   return null;
  // }

  // // Get the sequential course to show
  // const courseType2ToShow = getCourseToShowSequentially(coursesSortedArray);    
  // console.log("courseType2ToShow",courseType2ToShow);


  // // Also separate courses NOT of courseType 2 to show normally
  // const otherCourses = coursesSortedArray.filter(c => c.type !== 2);



  // === New: Sequential display logic for courseType === 2 ===
  const serialOrder = ["1", "2", "3", "4", "5"]; // Serial order for sorting

  // Function to get the course to show based on competitive exam type
  function getCourseToShowSequentially(allCourses, examType) {
    if (!Array.isArray(allCourses)) return null;

    // Filter courses where courseType == 2 and competitive_exam matches
    const filtered = allCourses.filter(c => c.type === 2 && c.competitive_exam === examType);

    // Sort by serialNumber order based on comp_course_serial_no
    filtered.sort(
      (a, b) => serialOrder.indexOf(a.comp_course_serial_no) - serialOrder.indexOf(b.comp_course_serial_no)
    );

    // Return the first course which is not completed
    for (const course of filtered) {
      if ((course.status ?? "").toLowerCase() !== "completed") {
        return course;
      }
    }

    // All completed? Return null (nothing to show)
    return null;
  }




  // Separate courses NOT of courseType 2 to show normally
  const otherCourses = coursesSortedArray.filter(c => c.type !== 2);




  //=============================================================================================================
  const [anchorEl, setAnchorEl] = useState(null);
  const open1 = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // useEffect(() => {
  //   if (addToCartData?.source !== 'MarketPlace') return;
  //   if (addToCartData?.message?.length) {
  //     toast.success(addToCartData?.message);
  //   }
  //   if (addToCartData?.error?.length) {
  //     toast.error(addToCartData?.error);
  //   }
  //   return () => {
  //     dispatch(resetAddToCart());
  //   };
  // }, [addToCartData]);


  return (
    <>
      <div className="studentDashboar-section">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div className="studentDashboar-wrapper">
                {/* BHumesh: MY suggested courses  */}
                <div className="studentDashboar-Suggested-Courses-wrapper">
                  <div className="studentDashboar-Suggested-Courses-short-by-filter-container">
                    <h3 className="studentDashboar-Suggested-Courses-short-by-filter-title" style={{ width: "305px" }}>Suggested Courses</h3>
                    <div className="suggestedcourse-search-sort">
                      <div className="studentDashboar-Suggested-Courses-short-by-filter-serach-inner-inpuut">
                        <div className="studentDashboar-search-filter">
                          <input
                            type="text"
                            name="search"
                            value={search}
                            onChange={serachhandleInputChange}
                            placeholder="Search courses, subjects, teachers"
                          />
                          <div className="serach-input-icon">
                            <ReactSVG src={imgs.svg.search} alt="" />
                          </div>
                        </div>
                      </div>
                      <div className="studentDashboar-Suggested-Courses-short-by-filter-section">
                        <div className="studentDashboar-Suggested-Courses-short-by-filter-inner-folder" style={{ cursor: "pointer" }}>
                          <span onClick={handleClick}><img src={sort} alt="sort" /> Sort</span>
                          <ReactSVG
                            id="demo-customized-button"
                            aria-controls={open1 ? "demo-customized-menu" : undefined}
                            aria-haspopup="true"
                            aria-expanded={open1 ? "true" : undefined}
                          // src={down_arrow}
                          />
                          <StyledMenu
                            anchorEl={anchorEl}
                            id="account-menu"
                            open={open1}
                            onClose={handleClose}
                            onClick={handleClose}
                            slotProps={{
                              paper: {
                                minWidth: 180,
                                elevation: 0,
                                sx: {
                                  overflow: "visible",
                                  // filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                                  mt: 1.5,
                                  "& .MuiAvatar-root": {
                                    w0idth: 32,
                                    height: 32,
                                    ml: -0.5,
                                    mr: 1,
                                  },
                                  "&:before": {
                                    content: '""',
                                    display: "block",
                                    position: "absolute",
                                    top: 0,
                                    right: 4,
                                    width: 10,
                                    height: 10,
                                    bgcolor: "background.paper",
                                    transform: "translateY(-50%) rotate(45deg)",
                                    zIndex: 0,
                                  },
                                },
                              },
                            }}
                            transformOrigin={{ horizontal: "right", vertical: "top" }}
                            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                          >
                            <MenuItem
                              selected={selectedSubject === ""}
                              onClick={() => changeSubjectFillter("")}
                            >
                              Most Relevent
                            </MenuItem>
                            <MenuItem
                              selected={selectedSubject === "price_low_to_high"}
                              onClick={() => changeSubjectFillter("price_low_to_high")}
                            >
                              Price: Low to High
                            </MenuItem>
                            <MenuItem
                              selected={selectedSubject === "price_high_to_low"}
                              onClick={() => changeSubjectFillter("price_high_to_low")}
                            >
                              Price: High to Low
                            </MenuItem>
                            {/* 
                          <MenuItem
                            selected={selectedSubject === "rating"}
                            onClick={() => changeSubjectFillter("rating")}
                          >
                            Rating
                          </MenuItem> */}
                            <MenuItem
                              selected={selectedSubject === "top_rated_teachers"}
                              onClick={() => changeSubjectFillter("top_rated_teachers")}
                            >
                              Top Rated Courses
                            </MenuItem>
                            <MenuItem
                              selected={selectedSubject === "top_rated_teachers"}
                              onClick={() =>
                                changeSubjectFillter("top_rated_teachers")
                              }
                            >
                              Top Rated Teachers
                            </MenuItem>
                          </StyledMenu>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="marketplace-sidebar">
                    {/* filter */}
                    <div className={` open`}>
                      {/* HEADER */}
                      <div className="drawer-header">
                        <h3><img src={FilterSVG} alt="filter" />Filter</h3>
                        <h4>Result({result?.result_count || 0})</h4>
                      </div>
                      <Filter setOpen={setOpen} filter={filter} setFilter={setFilter} isSuggested={true} setresult={setresult} />
                    </div>
                    {loading && <Grid
                      height={"50vh"}
                      xs={12}
                      container
                      justifyContent="center"
                      alignItems="center"
                    >
                      <CircularProgress size={80} />
                    </Grid>}
                    <div className="studentDashboar-Suggested-Courses-container marketplace-courses-container">
                      {
                        coursesSortedArray?.length > 0 && !loading ? (
                          coursesSortedArray
                            // Map to components
                            .map((course, index) => {
                              // Render teacher card if card_type is "teacher"
                              if (course.card_type === "teacher") {
                                return (
                                  <StudentSuggesionTeacherCard
                                    key={`teacher-${course.teacher_id}-${index}`}
                                    teacher={course}
                                    onNavigateAway={handleNavigateAway}
                                  />
                                );
                              }
                              // Render course card (original logic unchanged)
                              return (
                              <StudentSuggesionCourseData
                                onNavigateAway={handleNavigateAway}
                                key={index}
                                course={course}
                                from="/dashboard/market-place"
                              />
                            );
                            })
                        ) : coursesSortedArray?.length === 0 && !loading ? (<>    <div style={{
                          width: '100%',
                          gridColumn: '1 / -1',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          minHeight: '300px',
                          fontSize: '16px',
                          color: '#888'
                        }}>No Courses Found</div></>) : (null)}
                    </div>
                  </div>
                  {/* {!loading && coursesSortedArray?.length === 0 && (
                    <div className="no-courses-available-container">
                      <div>No Courses Found</div>
                    </div>
                  )} */}
                </div>
                <br />
                <Grid xs={12} container justifyContent={"center"}>
                  <Pagination
                    count={totalPages}
                    page={currentPage}
                    onChange={handlePageChange}
                    color="primary"
                    hideNextButton={
                      nextUrl === null || currentPage === totalPages
                    } // Disable if no next URL and on the last page
                    hidePrevButton={currentPage === 1} // Hide if no previous URL and on the first page
                  />
                </Grid>
                <FloatingAIButton
                  onClick={() => {
                    dispatch(setDrawerState(!chatDrawerState.isOpen));
                    dispatch(setIsWebAllowed(true));
                    dispatch(setQueryMetaData(null));
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MarketPlace;


